module.exports = __webpack_public_path__ + "static/media/icon-check-sign.5b2217e9.svg";